<template>
  <div class="fot">
    备案序号：浙ICP备19049905号&nbsp;&nbsp;浙江省卫生健康信息中心<br />浙公网安备:&nbsp;33010302001491号&nbsp;网站标识码:&nbsp;3300000005<br />Copyright(c)&nbsp;2000&nbsp;浙江省卫生健康委员会主办&nbsp;联系方式：87709006
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.fot {
  padding: 20px 0 20px 0;
  font-size: 12px;
  text-align: center;
  /* color: rgba(0, 0, 0, 0.6); */
  color: #fff;
  background: #303133;
}
</style>